export default [
  'ingredientDetail',
  'brandDetail',
  'consumerProductDetail',
  'formulationDetail',
  'tradeNameDetail'
].join()



// WEBPACK FOOTER //
// ./src/router/exclude.js